import React, { Component } from 'react';
import { Button, Row, Col, Form, Select, Spin, Tooltip, Modal, Input, message, Badge } from 'antd';
import { connect } from 'dva';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import SelectList from '../components/SelectList';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';

const { Option } = Select;
const { confirm } = Modal;
const { ListTable } = ListPage;
@connect(({ publicMass, microToPublic }) => ({
  ...publicMass,
  ...microToPublic,
}))
class PublicMass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinning: false,
      publicList: [],
      showPreview: false,
      WXname: '',
      params: {
        page: 1,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
        appCode: getAppCode(),
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
    };
  }

  componentDidMount() {
    this.fetchAllConfigure();
    const { params } = this.state;
    this.fetchPublishList(params);
  }

  fetchAllConfigure = () => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ spinning: true });
    dispatch({
      type: 'publicMass/fetchAllConfigure',
      params: {
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({ spinning: false, publicList: res || [] });
        if (res && res.length > 0) {
          this.setState({ params: { ...params, appid: res[0].appid } });
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchPublishList = params => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'microToPublic/fetchPublishList',
      params,
    })
      .then(res => {
        this.setState({
          spinning: false,
          list: res.content,
          params: { ...params, totalElements: res.totalElements },
        });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchUploadNews = type => {
    const { dispatch, form } = this.props;
    const { getFieldsValue } = form;
    const { selectedRowKeys, WXname } = this.state;
    const { appid } = getFieldsValue();
    const params = {
      ids: selectedRowKeys.join(','),
      appid,
      WXname,
      needPushToWX: type === 'preview' ? 0 : 1,
      previewWXNews: type === 'preview' ? 1 : 0,
      appCode: getAppCode(),
    };
    if (type === 'preview') {
      this.setState({ spinning: true });
      dispatch({
        type: 'publicMass/fetchUploadNews',
        params,
      })
        .then(() => {
          message.success('发送预览成功');
          this.setState({ spinning: false, WXname: '', showPreview: false });
        })
        .catch(() => {
          this.setState({ spinning: false });
        });
    } else {
      const that = this;
      confirm({
        title: '确认将文章内容发布至已绑定的公众号？',
        content: '',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          that.setState({ spinning: true });
          dispatch({
            type: 'publicMass/fetchUploadNews',
            params,
          })
            .then(() => {
              message.success('群发至公众号成功');
              that.setState({
                spinning: false,
                selectedRowKeys: [],
                selectedRows: [],
              });
            })
            .catch(() => {
              that.setState({ spinning: false });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  };

  handlePaginationChange = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.fetchPublishList(tempParams);
  };

  handleCancel = () => {
    this.setState({ WXname: '', showPreview: false });
  };

  handleOk = () => {
    const { WXname } = this.state;
    if (WXname.trim().length <= 0) {
      message.warning('请输入微信号');
      return;
    }
    this.fetchUploadNews('preview');
  };

  handleChange = value => {
    console.log('value', value);
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 330,
        fixed: 'left',
        render: title => (
          <Tooltip placement="top" title={title}>
            <span>{title?.length <= 20 ? title : `${title?.substring(0, 12)}...`}</span>
          </Tooltip>
        ),
      },
      {
        title: '群发至公众号',
        dataIndex: 'newsInfoExtend',
        key: 'newsInfoExtend',
        render: data => {
          const { pushWxTime } = data || {};
          return (
            <Badge
              color={pushWxTime ? '#52C41A' : '#C3C3C3'}
              text={pushWxTime ? '已群发' : '未群发'}
            />
          );
        },
      },
    ];

    return columns;
  };

  onSelectRow = (record, selected) => {
    const { selectedRowKeys, selectedRows } = this.state;
    let tempSelectedRows = [...selectedRows];
    let tempSelectedRowKeys = [...selectedRowKeys];
    if (selected && selectedRows.length === 8) {
      message.warning('最多只能选8篇');
      return;
    }
    if (selected && selectedRows.length < 8) {
      tempSelectedRowKeys.push(record.id);
      tempSelectedRows.push(record);
    } else if (!selected) {
      tempSelectedRowKeys = tempSelectedRowKeys.filter(itemKey => itemKey !== record.id);
      tempSelectedRows = tempSelectedRows.filter(item => item.id !== record.id);
    }

    this.setState({ selectedRowKeys: tempSelectedRowKeys, selectedRows: tempSelectedRows });
  };

  upItem = (record, index) => {
    const { selectedRows } = this.state;
    const tempArr = [];
    selectedRows.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num + 1) {
          tempArr.push(record);
        }
        tempArr.push(item);
      }
    });
    this.setState({ selectedRows: tempArr });
  };

  downItem = (record, index) => {
    const { selectedRows } = this.state;
    const tempArr = [];
    selectedRows.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num - 1) {
          tempArr.push(item);
          tempArr.push(record);
        } else {
          tempArr.push(item);
        }
      }
    });
    this.setState({ selectedRows: tempArr });
  };

  deleteItem = record => {
    const { selectedRows } = this.state;
    const tempArr = [];
    const idArr = [];
    selectedRows.forEach(item => {
      if (item.id !== record.id) {
        tempArr.push(item);
        idArr.push(item.id);
      }
    });
    this.setState({ selectedRows: tempArr, selectedRowKeys: idArr });
  };

  renderFooter = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button type="default" onClick={() => this.setState({ showPreview: true })}>
            预览
          </Button>
          <Button type="primary" onClick={() => this.fetchUploadNews()}>
            群发
          </Button>
        </>
      ),
    };
    return footerParams;
  };

  render() {
    const {
      spinning,
      publicList = [],
      params,
      showPreview,
      WXname,
      list,
      selectedRowKeys = [],
      selectedRows = [],
    } = this.state;

    const { page, pageSize, totalElements } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    const columns = this.setColumns();
    const rowSelection = {
      selectedRowKeys,
      onSelect: this.onSelectRow,
    };
    const tableProps = {
      pageInfo: {
        page,
        pageSize,
        totalElements,
      },
      columns,
      list,
      rowKey: 'id',
      onPageChange: this.handlePaginationChange,
      rowSelection,
    };

    const alertParams = {
      states: !0, // true为展示 false不展示
      type: 'info', // 错误类型（success info warning error）四种，默认为warning类型
      message: '群发为将内容同步更新至素材管理列表中并向已绑定的公众号直接发布内容。', // 展示的内容
    };

    return (
      <Container
        breStates={!0}
        version={2}
        alertParams={alertParams}
        footerParams={this.renderFooter()}
      >
        <div className={styles.root}>
          <Spin spinning={spinning}>
            <div className="select-public">
              <Form.Item {...formItemLayout} label="公众号">
                {getFieldDecorator('appid', {
                  initialValue: publicList && publicList[0] && publicList[0].appid,
                })(
                  <Select style={{ width: '100%' }} onChange={this.handleChange}>
                    {publicList.map(item => {
                      return <Option value={item.appid}>{item.subscribeName}</Option>;
                    })}
                  </Select>
                )}
              </Form.Item>
            </div>
            <section className="content">
              <div className="left">
                <SelectList
                  selectedRows={selectedRows}
                  tips="文章中附件内容无法同步至公众号,最多8篇"
                  deleteItem={this.deleteItem}
                  downItem={this.downItem}
                  upItem={this.upItem}
                />
              </div>
              <div className="right">
                <ListTable {...tableProps} />
              </div>
            </section>
          </Spin>
          <Modal
            title="发送预览"
            centered
            visible={showPreview}
            className={styles['modal-style']}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={[
              <Button onClick={this.handleCancel}>取消</Button>,
              <Button type="primary" loading={spinning} onClick={this.handleOk}>
                确定
              </Button>,
            ]}
          >
            <div className="tips">关注公众号后，才能接收图文消息预览</div>
            <Row>
              <Col span={3} className="wx-number">
                微信号
              </Col>
              <Col span={21}>
                <Input
                  value={WXname}
                  placeholder="请输入微信号"
                  onChange={e => this.setState({ WXname: e.target.value })}
                />
                <div className="wx-tips">
                  说明：预览功能仅用于公众号查看文章效果，不适用于公众传播，预览链接会在短期内失效
                </div>
              </Col>
            </Row>
          </Modal>
        </div>
      </Container>
    );
  }
}

const PublicMassFrom = Form.create()(PublicMass);
export default PublicMassFrom;
